import { render } from "./dialogCard.vue?vue&type=template&id=5bb91f24&scoped=true"
import script from "./dialogCard.vue?vue&type=script&lang=js"
export * from "./dialogCard.vue?vue&type=script&lang=js"

import "./dialogCard.vue?vue&type=style&index=0&id=5bb91f24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb91f24"]])

export default __exports__